module.exports = __webpack_public_path__ + "img/五味子.aa7b2e80.jpg";